import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	fetch: true,
	params: {
		limit: 5,
		offset: 0,
	},
	isFinal: false,
	total: null,
};

const payHistorySlice = createSlice({
	name: "payment_history",
	initialState,
	reducers: {
		get: (state) => {
			state.fetch = true;
		},
		set: (state, action) => {
			state.total = action.payload.total;
			state.list = action.payload.data;
			state.fetch = false;
		},
		drop: () => initialState,
		changePage: (state, action) => {
			state.params.offset = action.payload * state.params.limit;
		},
	},
});

export const payHistoryActions = payHistorySlice.actions;
export const payHistoryReducer = payHistorySlice.reducer;
